var render, staticRenderFns
import script from "./SalesYear.component.ts?vue&type=script&lang=ts&"
export * from "./SalesYear.component.ts?vue&type=script&lang=ts&"
import style0 from "./SalesYear.component.scss?vue&type=style&index=0&id=0d93a3e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93a3e9",
  null
  
)

export default component.exports